import ServiceRequestDetail from "./serviceRequestDetail";
import {connect} from "react-redux";
import { addEmail, getServiceDetail } from "../../../../redux/actions/incidentManagement/serviceDetails.action";
import { serviceRequestDownloadFiles } from "../../../../redux/actions/fileAttachment/fileAttachment.actions";
import { getServiceComments, clearServiceComments } from "../../../../redux/actions/incidentManagement/serviceComment.action";
import { showAlertPopup } from "../../../../redux/actions/AlertErrorMessage/alertErrorMessage.action";
import { ReadNotification } from "../../../../redux/actions/notification/getEventNotificationList.action";
import { openAlertPopup } from "../../../../redux/actions/Alert/alert.action";
const mapStateToProps = (state) => {
    return {
        serviceDetails: state.serviceDetails.serviceDetails,    
        loading: state.serviceDetails.loading, 
        next: state.serviceComment.next,
        comments: state.serviceComment.comments,
        isCommentsLoading:state.serviceComment.isLoading,
        myRights : state.myRights.myRights
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getServiceDetail: (requestId)=>{
            return dispatch(getServiceDetail(requestId))
          },
          serviceRequestDownloadFile:(originalFileName,uniqueFileName,messageId,attachmentId,graphInternetMessageId)=>{
            return dispatch(serviceRequestDownloadFiles(originalFileName,uniqueFileName,messageId,attachmentId,graphInternetMessageId))
          },
          getServiceComments:(requestId,next=null)=>{
            return dispatch(getServiceComments(requestId,next))
          },
          clearServiceComments:()=>{
            return dispatch(clearServiceComments())
          },
          showAlertPopup: (alertHeader,alertmessage) => {
            return dispatch(showAlertPopup(alertHeader,alertmessage))
          },
          ReadNotification: (payload,id) => {
            return dispatch(ReadNotification(payload,id))
          },
          addEmail: (payload,id) => {
            return dispatch(addEmail(payload,id))
          },
          openAlertPopup: (payload) => {
            return dispatch(openAlertPopup(payload))
          },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestDetail);
